import { FanModel } from '@modules/fan/fan-model';

const { fields } = FanModel;

export default [
  fields.name,
  fields.lastName,
  fields.picture,
  fields.uid,
  fields.teams,
];
